import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

import {
  createRootRouteRefsPair,
  createSubRouteRefsPair,
} from '@spotify/confidence-core-react';

export enum RoutesIds {
  initiatives = 'initiatives',
  initiative = 'initiative',
  initiativeSettings = 'initiativeSettings',
}

enum ExternalRoutesIds {
  experimentationPlatformInitiative = 'experimentationPlatformInitiative',
}

// root route
export const [initiativesRouteImplRef, initiativeIndexRouteRef] =
  createRootRouteRefsPair({ id: RoutesIds.initiatives });

export const rootRouteRef = initiativesRouteImplRef;

// sub-routes within the plugin
export const [initiativeRouteImplRef, initiativeRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.initiative,
    parent: rootRouteRef,
    path: '/:id',
  });

export const [initiativeSettingsRouteImplRef, initiativeSettingsRouteRef] =
  createSubRouteRefsPair({
    id: RoutesIds.initiativeSettings,
    parent: rootRouteRef,
    path: '/:id/settings',
  });

// external routes to other systems (for backward compatibility during migration)
export const experimentationPlatformInitiativeRouteRef = createExternalRouteRef(
  {
    id: 'backstage-experimentation-platform-initiative',
    params: ['id'],
    optional: true,
  },
);

// default routes/routes to be used by other plugins
export const Routes = {
  initiatives: initiativesRouteImplRef,
  initiative: initiativeRouteImplRef,
  initiativeSettings: initiativeSettingsRouteImplRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // sub-routes within the plugin
  initiatives: initiativeIndexRouteRef,
  initiative: initiativeRouteRef,
  initiativeSettings: initiativeSettingsRouteRef,

  // external routes to other systems
  experimentationPlatformInitiative: experimentationPlatformInitiativeRouteRef,
} satisfies Record<RoutesIds, ExternalRouteRef> &
  Record<ExternalRoutesIds, ExternalRouteRef>;
